import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2ad3250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "greeting-message" }
const _hoisted_3 = { class: "greeting-message-avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "greeting-message-bubble" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.managerAvatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.managerAvatar,
              alt: ""
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.lastName) + " " + _toDisplayString(_ctx.firstName) + " :\n        ", 1),
        _createTextVNode(),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.message), 1)
      ])
    ])
  ]))
}